import React, { useState, useEffect, useRef } from 'react';
import { AdminSidebarLayout } from '../../components/AdminSidebar';
import Step1 from '../../components/admins/new-gig/Step1';
import Step2 from '../../components/admins/new-gig/Step2';
import Step3 from '../../components/admins/new-gig/Step3';

const NewGig = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    keywords: [],           // array of tag IDs
    selectedHellocians: [], // array of hellocian IDs
    selectedCategories: [], // array of category IDs
    images: [],
    pricing: {
      basic:    { title: '', description: '', deliveryDays: '', price: '' },
      standard: { title: '', description: '', deliveryDays: '', price: '' },
      advanced: { title: '', description: '', deliveryDays: '', price: '' },
      pro:      { title: '', description: '', deliveryDays: '', price: '' },
      premium:  { title: '', description: '', deliveryDays: '', price: '' },
    },
    addons: [
      { name: 'Unlimited Revisions', selected: [false, false, false, false, false] }
    ]
  });

  const fileInputRef = useRef(null);

  // Persist form data in localStorage
  useEffect(() => {
    const savedData = localStorage.getItem('gigCreationData');
    const savedStep = localStorage.getItem('gigCreationStep');

    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        // images can't be persisted (File objects), keep empty
        setFormData({ ...parsed, images: [] });
      } catch (_) {}
    }

    if (savedStep) {
      setCurrentStep(parseInt(savedStep));
    }

    const urlParams = new URLSearchParams(window.location.search);
    const stepParam = urlParams.get('step');
    if (stepParam) {
      setCurrentStep(parseInt(stepParam));
    }
  }, []);

  useEffect(() => {
    // Persist data except images (File objects aren't serialisable)
    const toSave = { ...formData, images: [] };
    localStorage.setItem('gigCreationData', JSON.stringify(toSave));
  }, [formData]);

  useEffect(() => {
    const url = new URL(window.location);
    url.searchParams.set('step', currentStep);
    window.history.pushState({}, '', url);
    localStorage.setItem('gigCreationStep', currentStep);
  }, [currentStep]);

  const isNextEnabled = () => {
    if (currentStep === 1) {
      return (
        formData.title &&
        formData.keywords.length > 0 &&
        formData.selectedHellocians.length > 0 &&
        formData.selectedCategories.length > 0
      );
    }
    return true;
  };

  return (
    <AdminSidebarLayout currentPath={"/new-gig"}>
      <div className="bg-gray-50 dark:bg-[#0b0e14] min-h-screen font-['Poppins'] transition-colors duration-200">
        <div className="container mx-auto px-4 py-8">
          <div className="text-sm breadcrumbs mb-4 text-gray-500 dark:text-gray-400">
            <span>Pages</span> / <span>Dashboard</span> /{' '}
            {currentStep === 1 ? (
              <span>Add New Gig</span>
            ) : currentStep === 2 ? (
              <span>Description</span>
            ) : (
              <span>Gig Pricing</span>
            )}
          </div>

          <h1 className="text-3xl font-bold text-[#174568] dark:text-white mb-8">
            {currentStep === 1 ? 'Add New Gig' : currentStep === 2 ? 'Gig Description' : 'Gig Pricing'}
          </h1>

          {/* Step Indicator */}
          <div className="flex items-center mb-8">
            {[1, 2, 3].map((step) => (
              <React.Fragment key={step}>
                <div className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold transition-colors duration-200
                  ${currentStep >= step 
                    ? 'bg-[#174568] dark:bg-blue-600 text-white' 
                    : 'bg-gray-200 dark:bg-[#1d2026] text-gray-500 dark:text-gray-400'}`}>
                  {step}
                </div>
                {step < 3 && (
                  <div className={`flex-1 h-1 mx-2 transition-colors duration-200 ${currentStep > step ? 'bg-[#174568] dark:bg-blue-600' : 'bg-gray-200 dark:bg-[#1d2026]'}`} />
                )}
              </React.Fragment>
            ))}
          </div>

          {currentStep === 1 && (
            <Step1
              formData={formData}
              setFormData={setFormData}
              fileInputRef={fileInputRef}
              isNextEnabled={isNextEnabled}
              setCurrentStep={setCurrentStep}
            />
          )}

          {currentStep === 2 && (
            <Step2
              formData={formData}
              setFormData={setFormData}
              setCurrentStep={setCurrentStep}
            />
          )}

          {currentStep === 3 && (
            <Step3
              formData={formData}
              setFormData={setFormData}
              setCurrentStep={setCurrentStep}
            />
          )}
        </div>
      </div>
    </AdminSidebarLayout>
  );
};

export default NewGig;